import { RootState } from "../rootStore";
export const selectAtheletesList = ({ athletes }: RootState) =>
  athletes.atheletesList;

  export const selectTotalAtheletes = ({ athletes }: RootState) =>
  athletes.totalAthletesList;

  export const selectLoadingAtheletes = ({ athletes }: RootState) =>
  athletes.loadingAtheletes;
